import { repeat, replace } from 'lodash';

import { captureException } from 'src/lib/sentry';

export const KEYWORDS_SEPARATOR = ', ';

const formatDynamicKeyword = (keyword) => `/keyword [${keyword}]`;
const DYNAMIC_KEYWORD_DAY_OF_WEEK = formatDynamicKeyword('DayOfWeek');
const DYNAMIC_KEYWORD_COUNTRY = formatDynamicKeyword('Country');
const DYNAMIC_KEYWORD_CITY = formatDynamicKeyword('City');

export const DYNAMIC_KEYWORDS = [
  DYNAMIC_KEYWORD_DAY_OF_WEEK,
  DYNAMIC_KEYWORD_COUNTRY,
  DYNAMIC_KEYWORD_CITY,
];

export const includesDynamicKeyword = (keywords) =>
  keywords.some((keyword) => DYNAMIC_KEYWORDS.includes(keyword));

const DAY_OF_WEEK_CORRECTED_LENGTH = 9;
export const replaceDynamicKeywordsForLength = (text) => {
  if (text.includes(DYNAMIC_KEYWORD_DAY_OF_WEEK)) {
    const placeholder = repeat('X', DAY_OF_WEEK_CORRECTED_LENGTH);
    return replace(text, DYNAMIC_KEYWORD_DAY_OF_WEEK, placeholder);
  }

  return text;
};

export const parseBlogSupportingKeywords = (supportingKeywords) => {
  try {
    return supportingKeywords ? JSON.parse(supportingKeywords) : [];
  } catch (error) {
    captureException(error, {
      extra: {
        source: 'data/keywords.js -> parseBlogSupportingKeywords',
      },
    });
  }
  return null;
};
